export const stopPropagation = (e: React.SyntheticEvent): void => e.stopPropagation();
export const stopImmediatePropagation = (e: React.SyntheticEvent): void =>
  e.nativeEvent.stopImmediatePropagation();
export const preventDefault = (e: React.SyntheticEvent): void => e.preventDefault();
